import AuthService from 'library/authService/auth-service';

// States in which Optimiser-gated UI must be shown (FR-6.2): readiness_checking
// (so admins can tag users/activities to clear validation violations) and enabled.
// Mirrors the backend's write-protected states.
export const OPTIMISER_ACTIVE_STATES = ['readiness_checking', 'enabled'];

// Single source of truth for "should this tenancy see Optimiser content".
// Reads currentTenancy.optimiserState (mapped from the tenancy serializer's
// optimiser_state), which is 'disabled' | 'readiness_checking' | 'enabled'.
export const isOptimiserActive = (tenancy) => {
  let currentTenancy = tenancy;
  if (!currentTenancy) {
    const user = AuthService.whoami() || {};
    currentTenancy = user.currentTenancy || {};
  }
  return OPTIMISER_ACTIVE_STATES.includes(currentTenancy.optimiserState);
};

const hasOptimiserPermission = (perm) => {
  const user = AuthService.whoami() || {};
  return (user.currentTenancyPermissions || []).includes(perm);
};

// Combined gate: tenancy Optimiser-active AND the user holds the permission.
// admin implies view. Permissions are always for the current tenancy.
export const canViewOptimiser = tenancy => isOptimiserActive(tenancy)
  && (hasOptimiserPermission('can_view_optimiser') || hasOptimiserPermission('can_admin_optimiser'));

export const canAdminOptimiser = tenancy => isOptimiserActive(tenancy)
  && hasOptimiserPermission('can_admin_optimiser');
